import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { UnsubscribeService } from '@webgate/angular-azure-core';
import { Actions } from 'src/app/models/Actions';
import { Keyword } from 'src/app/models/keyword';
import { CompareService } from 'src/app/services/compare.service';
import { KeywordsService } from 'src/app/services/keywords.service';

import { AdminKeywordEditDialogComponent } from './edit-keyword-dialog/edit-keyword-dialog.component';

@Component({
  selector: 'app-admin-keywords',
  imports: [CommonModule, FormsModule, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './admin-keywords.component.html',
  styleUrl: './admin-keywords.component.scss'
})
export class AdminKeywordsComponent implements OnInit {
  dialog = inject(MatDialog);
  keywordsService = inject(KeywordsService);
  unsubscribeService = inject(UnsubscribeService);
  compareService = inject(CompareService);
  cdr = inject(ChangeDetectorRef);

  allKeywords: Keyword[] = [];
  filteredKeywords: Keyword[] = [];
  searchTerm: string = '';

  ngOnInit(): void {
    this.loadKeywords();
  }

  loadKeywords(): void {
    this.keywordsService
      .getAllKeywords()
      .pipe(this.unsubscribeService.takeUntilDestroy)
      .subscribe((keywords: Keyword[]) => {
        const lstKW = keywords || [];
        lstKW.sort((a: Keyword, b: Keyword) => {
          return this.compareService.compare(a.keywordName, b.keywordName, true);
        });
        this.allKeywords = lstKW;
        this.applyFilter();
        // Trigger change detection to update the view immediately
        this.cdr.detectChanges();
      });
  }

  applyFilter(): void {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      this.filteredKeywords = [...this.allKeywords];
    } else {
      const term = this.searchTerm.toLowerCase().trim();
      this.filteredKeywords = this.allKeywords.filter(
        (keyword) =>
          keyword.keywordName.toLowerCase().includes(term) ||
          keyword.keywordValues?.some(
            (v) => v.keywordValueName?.toLowerCase().includes(term) || v.description?.toLowerCase().includes(term)
          )
      );
    }
    // Trigger change detection when filter is applied
    this.cdr.markForCheck();
  }

  btnAddNewKeyword(): void {
    const newKW = new Keyword();
    newKW.id = '';
    this.btnEditKeyword(newKW);
  }

  btnEditKeyword(keyword: Keyword): void {
    this.dialog
      .open(AdminKeywordEditDialogComponent, {
        data: { keyword },
        minWidth: '800px'
      })
      .afterClosed()
      .pipe(this.unsubscribeService.takeUntilDestroy)
      .subscribe((result: Actions) => {
        if (result === Actions.Refresh) this.loadKeywords();
      });
  }
}
